/**
 * ATC ensembles LP — réplique du flux "combo" du widget Rebolt (PDP) :
 *   1. get-bundles        → config du bundle (combo_bundle_list.bundle_detail)
 *   2. verify-buildbox    → box_key + attribut panier (a_key/a_value = rb_sh_box)
 *   3. /cart/add.js       → variante PARENT (is_shopify_bundle "1") ou composants ("2")
 *                           avec properties._th_bundle_uid + attributes[a_key]
 *   Le Cart Transform Rebolt éclate ensuite le parent en composants
 *   (prix remisé, stocks décrémentés sur les composants), comme sur la PDP.
 *
 * Fallback : si Rebolt est injoignable, ajout des 2 variantes seules (plein tarif).
 */
(function () {
  var cache = Object.create(null);
  var API = 'https://rebolt.bristm.com/rebolt-bundle/front';

  function uid() {
    return Date.now().toString(36) + Math.random().toString(36).substr(2);
  }

  function sf() {
    return window.Shopify || {};
  }

  function currencyRate() {
    var c = sf().currency || {};
    return c.rate || '1';
  }

  function shopParams(productId) {
    var Shopify = sf();
    var st = window.__st || {};
    // Même jeu de paramètres (et même ordre) que reboltScript.js
    return {
      active_country: Shopify.country || '',
      active_currency: (Shopify.currency && Shopify.currency.active) || '',
      cart_products: '',
      cart_bids: '',
      page_id: String(productId),
      page_type: 'product',
      product_id: String(productId),
      shop: Shopify.shop || '',
      locale: Shopify.locale || 'fr',
      customer_id: st.cid || '',
      abtest_ids: ''
    };
  }

  function toQuery(obj) {
    return Object.keys(obj)
      .map(function (k) {
        var v = obj[k];
        if (v === null || v === undefined) v = '';
        return encodeURIComponent(k) + '=' + encodeURIComponent(v);
      })
      .join('&');
  }

  function cartRoot() {
    var r = sf().routes;
    return (r && r.root) || '/';
  }

  function parseRebolt(res) {
    return res.text().then(function (text) {
      if (!text || text.indexOf('Restricted') === 0) return null;
      try {
        return JSON.parse(text);
      } catch (e) {
        return null;
      }
    });
  }

  function pickBundle(data) {
    if (!data || Number(data.status) !== 200) return null;
    var combo = data.combo_bundle_list;
    if (combo && combo.bundle_detail && combo.bundle_detail.id) {
      var detail = combo.bundle_detail;
      detail.product_list = combo.product_list || [];
      return detail;
    }
    var list = data.bundle_list || [];
    if (list.length && list[0].bundle_detail) return list[0].bundle_detail;
    if (data.bundle_detail) return data.bundle_detail;
    return null;
  }

  function fetchBundleConfig(productId) {
    if (!productId) return Promise.resolve(null);
    if (cache[productId]) return cache[productId];

    cache[productId] = fetch(API + '/get-bundles?' + toQuery(shopParams(productId)), {
      headers: { Accept: 'application/json, text/plain, */*' },
      credentials: 'omit',
      mode: 'cors'
    })
      .then(parseRebolt)
      .then(pickBundle)
      .catch(function (err) {
        console.warn('[ed-duo-atc] get-bundles failed', err);
        return null;
      })
      .then(function (bundle) {
        if (!bundle) delete cache[productId];
        return bundle;
      });

    return cache[productId];
  }

  function postCartItems(items, attributes) {
    var body = { items: items };
    if (attributes) body.attributes = attributes;

    return fetch(cartRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          var err = new Error((data && data.description) || 'add failed');
          err.payload = data;
          throw err;
        }
        return Object.assign({}, data, { status: res.status });
      });
    });
  }

  function openCart(result) {
    if (typeof window.reboltCartCallBack === 'function') {
      window.reboltCartCallBack(result);
      return;
    }
    document.dispatchEvent(
      new CustomEvent('ajaxProduct:added', { detail: { product: result } })
    );
  }

  function getCartAttributes() {
    var k = uid();
    return fetch(cartRoot() + 'cart.js?' + k + '=' + k, {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        return (cart && cart.attributes) || {};
      })
      .catch(function () {
        return {};
      });
  }

  function buildPlainItems(pieces, genre) {
    var g = genre || 'femme';
    return pieces.map(function (p) {
      return {
        id: Number(p.variantId),
        quantity: 1,
        properties: { Genre: g, Ensemble: p.side || '' }
      };
    });
  }

  function buildReboltItems(pieces, bundle) {
    var bundleUid = uid();
    var displayType = bundle.bundle_display_type || 'product';
    return pieces.map(function (p) {
      return {
        id: Number(p.variantId),
        quantity: 1,
        properties: {
          _rb_bundle_id: String(bundle.id),
          _rb_bundle_type: String(displayType),
          _rb_bundle_uid: bundleUid
        }
      };
    });
  }

  function keyPrefix(bundle) {
    var t = String(bundle.bundle_display_type || '');
    if (t === 'combo') return 'shcombo_';
    if (t === 'buildbox' || t === 'build_box') return 'shbuildbox_';
    return 'shproduct_';
  }

  function parentVariantId(bundle, opts) {
    var cp = bundle.created_product || {};
    return cp.variant_id || bundle.variant_id || (opts && opts.parentVariantId) || null;
  }

  /**
   * Flux Shopify-bundle Rebolt (is_shopify_bundle "1"/"2") — identique au widget PDP.
   */
  function addViaShopifyBundle(bundle, pieces, opts) {
    var Shopify = sf();
    var bundleKey = keyPrefix(bundle) + bundle.id + '_' + uid();
    var items = pieces.map(function (p) {
      return {
        quantity: 1,
        product_id: String(p.productId),
        variant_id: String(p.variantId)
      };
    });

    return getCartAttributes()
      .then(function (attrs) {
        var body = {
          shop: Shopify.shop,
          active_country: Shopify.country || '',
          active_currency: (Shopify.currency && Shopify.currency.active) || '',
          currency_rate: currencyRate(),
          box_attribute: attrs.rb_sh_box || '{}',
          bundle_array: [{ bundle_id: bundle.id, bundle_key: bundleKey, items: items }]
        };
        return fetch(API + '/verify-buildbox', {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain', Accept: 'application/json, text/plain, */*' },
          body: JSON.stringify(body),
          credentials: 'omit',
          mode: 'cors'
        }).then(parseRebolt);
      })
      .then(function (verified) {
        if (!verified || Number(verified.status) !== 200 || !verified.data) {
          var err = new Error('verify-buildbox failed');
          err.payload = verified;
          throw err;
        }
        var data = verified.data;
        var props = { _th_bundle_uid: data.box_key };
        var lineItems;

        if (String(bundle.is_shopify_bundle) === '2') {
          lineItems = pieces.map(function (p) {
            return { id: Number(p.variantId), quantity: 1, properties: props };
          });
        } else {
          var pvid = parentVariantId(bundle, opts);
          if (!pvid) throw new Error('parent variant id missing');
          lineItems = [{ id: Number(pvid), quantity: 1, properties: props }];
        }

        var cartAttrs = {};
        cartAttrs[data.a_key] = data.a_value;
        return postCartItems(lineItems, cartAttrs);
      });
  }

  function addEnsemble(opts) {
    var productId = opts && opts.productId;
    var pieces = (opts && opts.pieces) || [];
    var genre = (opts && opts.genre) || 'femme';
    if (!productId || pieces.length < 2) {
      return Promise.reject(new Error('missing ensemble selection'));
    }

    return fetchBundleConfig(productId)
      .then(function (bundle) {
        if (bundle && bundle.id) {
          var isSb = String(bundle.is_shopify_bundle || '');
          if (isSb === '1' || isSb === '2') {
            return addViaShopifyBundle(bundle, pieces, opts).catch(function (err) {
              console.error('[ed-duo-atc] verify-buildbox KO — fallback pièces seules', err, err && err.payload);
              return postCartItems(buildPlainItems(pieces, genre));
            });
          }
          return postCartItems(buildReboltItems(pieces, bundle));
        }
        console.error('[ed-duo-atc] Rebolt config indisponible — ajout pièces seules (plein tarif)');
        return postCartItems(buildPlainItems(pieces, genre));
      })
      .then(function (res) {
        openCart(res);
        return res;
      });
  }

  window.petroneEdDuoAtc = {
    add: addEnsemble,
    preload: fetchBundleConfig
  };
})();
